module.exports = __webpack_public_path__ + "img/图片1-3.7eda85f9.png";